
var Mediator = require('./Mediator.js');

/**
 * 管理输入框TextArea
 */
var InputText = {
  isInput: false,

  textNode: null,
  textPadding: 10,
  font: null,
  box: null,

  backLayerCid: -1,
  textLayerCid: -1,

  figureTextWidth: function (text, obj, boxLayer) {
    var maxWidth = Math.abs(boxLayer.width) - 20;
    var maxHeight = Math.abs(boxLayer.height) - 20;
    var context = Mediator.getCanvas().getContext('2d');
    context.font = parseInt(obj.fontSize, 10) + 'px ' + obj.fontFamily;
    var len = 0;
    var tempStr = '';
    var strs = [];
    var result = [];
    for (var i = 0; i < text.length; i++) {
      if(text[i] === '\n') {
        strs.push(tempStr);
        tempStr = '';
        len = 0;
        continue;
      }
      var l = context.measureText(text[i]).width;
      if ((len + l) > maxWidth) {
        strs.push(tempStr);
        if(l <= maxWidth) {
          tempStr = text[i];
        }
        len = l;
        continue;
      }

      tempStr += text[i];
      len = len + l;
    }
    strs.push(tempStr);
    var h = 0;
    for (var i = 0; i < strs.length; i++) {
      if ((h + parseInt(obj.fontSize, 10)) > maxHeight) {
        break;
      }
      result.push(strs[i]);
      h += parseInt(obj.fontSize, 10);
    }
    return result.join('\n');
  },

  isChange: false,
  saveTextData: function() {
    if (this.isInput) {
      var textValue = $(this.textNode).val();
      var backLayer = Mediator.getLayerByCid(this.backLayerCid);
      var textLayer = Mediator.getLayerByCid(this.textLayerCid);
      if (backLayer) {
        if (!textLayer) {
          Mediator.appendTextLayer(textValue);
          this.isChange = true;     //添加了新图层，做保存。（有没有文字都应该保存）
        }
        Mediator.showLayer(backLayer);
        Mediator.setCurrentCid(backLayer.data.cid);
        Mediator.switchToEdit();
      }

      if(this.isChange) {
        this.isChange = false;
        Mediator.restore();
      }
      this.isInput = false;
    }
    $(this.textNode).val('');
    $(this.textNode).css('display', 'none');
  },

  openTextArea: function() {
    InputText.isInput = true;
    this.isChange = false;
    var relativeLayers = Mediator.getBindLayers(Mediator.getCurrentLayer());
    this.backLayerCid =-1;
    this.textLayerCid = -1;
    var backLayer = relativeLayers[0];
    var textLayer = relativeLayers[1];

    if (backLayer) {
      this.backLayerCid = backLayer.data.cid;
      Mediator.hiddenLayer(backLayer);
      this.box = {x: backLayer.x, y: backLayer.y, height: backLayer.height, width: backLayer.width};
      this.font = {
        fontSize: Mediator.getStyle('TextTool', 'fontSize'),
        fontFamily: '微软雅黑',
        color: Mediator.getStyle('TextTool', 'color'),
        text: ''
      };
      if(textLayer) {
        this.textLayerCid = textLayer.data.cid;
        this.font.fontSize = textLayer.fontSize;
        this.font.fontFamily = textLayer.fontFamily;
        this.font.color = textLayer.fillStyle;
        this.font.text = textLayer.data.text;
      }
      InputText.editText();
      //暂定策略，输入状态下不加载选择点，看起来很怪异
      Mediator.clearPoints();
    }
  },

  editText: function() {
    //首先更新宽度，宽度会影响到高度的计算
    InputText.updateLayerWidth();
    var height = InputText.figureTextHeight();
    InputText.updateLayerHeight(height);
    //更新文本应放在更新背景之后，显示多少文字由宽度、高度控制
    InputText.updateLayerText();
    InputText.adjustTextArea();
  },

  figureTextHeight: function() {
    var text = this.font.text;
    var fontSize = parseInt(this.font.fontSize, 10);
    var fontFamily = this.font.fontFamily;
    var box = this.box;
    if(!text || text === '') {
      return 0;
    }
    var maxWidth = box.width - this.textPadding*2
    var context = Mediator.getCanvas().getContext('2d');
    context.font = fontSize + 'px ' + fontFamily;
    var len = 0;
    var tempStr;
    var strs = [];
    for (var i = 0; i < text.length; i++) {
      if(text[i] === '\n') {
        strs.push(tempStr);
        tempStr = '';
        len = 0;
        continue;
      }
      var l = context.measureText(text[i]).width;
      if ((len + l) > maxWidth) {
        if(tempStr !== undefined) {
          strs.push(tempStr);
        }
        tempStr = text[i];
        len = l;
        continue;
      }

      if(tempStr === undefined) {
        tempStr = '';
      }
      tempStr += text[i];
      len = len + l;
    }
    strs.push(tempStr);

    return strs.length*fontSize;
  },

  updateLayerText: function() {
    var textLayer = Mediator.getLayerByCid(this.textLayerCid);
    if(textLayer) {
      if(textLayer.data.text !== this.font.text) {     //文本改变，应该保存一次状态
        this.isChange = true;
      }
      //背景宽高改变后，文字的坐标响应改变
      textLayer.x = Math.min(this.box.x, this.box.x+this.box.width) + this.textPadding;
      textLayer.y = Math.min(this.box.y, this.box.y+this.box.height) + this.textPadding;
      textLayer.data.text = this.font.text;
      //此处计算显示多少文字，计算时需要依赖背景高度和宽度
      textLayer.text = InputText.figureTextWidth(this.font.text, this.font, this.box);
    }
  },

  updateLayerWidth: function() {
    var backLayer = Mediator.getLayerByCid(this.backLayerCid);
    if(Math.abs(backLayer.width) <= this.textPadding*2+parseInt(this.font.fontSize)) {

      backLayer.x = Math.min(backLayer.x, backLayer.x+backLayer.width);
      backLayer.width = this.textPadding*2+parseInt(this.font.fontSize);
      //更新背景时，同步更新文字工具的大小
      this.box.x = backLayer.x;
      this.box.width = backLayer.width;
      //背景大小改变，应该保存状态
      this.isChange = true;
    }
    $(Mediator.getCanvas()).drawLayers();
  },

  updateLayerHeight: function(height) {
    var backLayer = Mediator.getLayerByCid(this.backLayerCid);

    if(height > Math.abs(backLayer.height)-this.textPadding*2) {

      backLayer.y = Math.min(backLayer.y, backLayer.y+backLayer.height);
      backLayer.height = height + this.textPadding*2;
      //更新背景时，同步更新文字工具的大小
      this.box.y = backLayer.y;
      this.box.height = backLayer.height;
      //背景大小改变，应该保存状态
      this.isChange = true;
    }
  },

  //根据背景图层数据矫正textArea(频繁更新)
  adjustTextArea: function() {
    var backLayer = Mediator.getLayerByCid(this.backLayerCid);
    var textAreaStyle = {
      display: 'block',
      left: Math.min(backLayer.x, backLayer.x+backLayer.width),
      top: Math.min(backLayer.y, backLayer.y+backLayer.height),
      width: Math.abs(backLayer.width)-this.textPadding*2,
      height: Math.abs(backLayer.height)-this.textPadding*2,
      background: backLayer.fillStyle,
      fontSize: this.font.fontSize,
      color: this.font.color,
    };
    this.textNode = ReactDOM.findDOMNode(Mediator.getRef('text'));
    $(this.textNode).css(textAreaStyle);
    $(this.textNode).focus();
    $(this.textNode).val(this.font.text);
  },

  adapteText: function(text, backLayer) {
    if(text && text !== '') {
      this.font.text = text;
      InputText.editText();
    }
  },
};

module.exports = InputText;


// WEBPACK FOOTER //
// ./src/helper/Review/InputText.js